import { __ } from '@wordpress/i18n'

export default { notFoundMessage: __("Enter video's URL", 'dhsv_theme') }
